import { Control, useController } from 'react-hook-form';

import { CampaignRejectionFormValues } from './types';
import {
  createMaxLengthValidator,
  createRequiredValidator,
  isValidInput,
} from '@/utils/validators';

export const useControllers = (
  control: Control<
    CampaignRejectionFormValues,
    any,
    CampaignRejectionFormValues
  >
) => {
  const {
    field: {
      value: explanation,
      onChange: setExplanation,
      onBlur: validateExplanation,
    },
    fieldState: { error: explanationError },
  } = useController({
    control,
    name: 'explanation',
    rules: {
      validate: {
        isRequired: createRequiredValidator(
          'Please enter Detailed Explanation'
        ),
        isValidInput,
        withValidMaxLength: createMaxLengthValidator(3000),
      },
    },
  });

  return {
    explanation,
    setExplanation,
    validateExplanation,
    explanationError,
  };
};
